import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { exitActionKiosk } from "../../../../store/actions";
import logo from '../../../../images/M42_logo.png';
import { IKIOSKModel, IkioskMenuIds } from "../../../../models/kioskModel2";
import { getSessionTimeout } from "../../../../helpers/helpersIndex";
function SessionTimeOut() {
  let dispatch = useDispatch();
  const menuType: any = useSelector((state: any) => (state?.kioskReducer2 as IKIOSKModel)?.selectedPage || undefined);
  const sessionEndtime: number = useSelector((state: any) => (state?.kioskReducer2 as IKIOSKModel)?.kioskConfigdata?.pageTimeout || getSessionTimeout());
  const [count, setCount] = useState(menuType === IkioskMenuIds.LOGINPAGE ? sessionEndtime : sessionEndtime);
  const loading: boolean = useSelector((state: any) => (state.kioskReducer2 as IKIOSKModel)?.loading || false);

  useEffect(() => {
    let subscribe;
    if (!loading && !([IkioskMenuIds.LOGINPAGE, IkioskMenuIds.PROMOTIONALSLIDE].includes(menuType)))
      if (count > 0) {
        subscribe = setTimeout(() => {
          setCount(count - 1);
        }, 1000);
      }
      else if (count === 0) {
        dispatch(exitActionKiosk())
      }
    return () => {
      clearTimeout(subscribe);
    }
  }, [count,menuType,loading,dispatch]);

  
  useEffect(() => {
   setCount(sessionEndtime);
  }, [menuType,sessionEndtime]);

  const secondsToTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes.toString().padStart(1, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
  }
  return (
    <>
      {menuType &&
        <header className='Kiosk_header'>
          <img src={logo} alt="logo" width="310" />
          {!loading && !([IkioskMenuIds.LOGINPAGE, IkioskMenuIds.PROMOTIONALSLIDE].includes(menuType)) && <span className='Kiosk_timer'>{secondsToTime(count)}</span>}
        </header>}
    </>
  )
}
export default React.memo(SessionTimeOut);
